import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'app-test-control',
  templateUrl: './test-control.component.html',
  styleUrls: ['./test-control.component.scss'],
})
export class TestControlComponent implements OnInit {
  @Input() control: UntypedFormControl;

  constructor() {
    // ngControl.valueAccessor
  }

  ngOnInit(): void {}
}
